export enum LOYALTY_APPLY_STATUS {
  SENDING = 'SENDING',
  PROCESSING = 'PROCESSING',
  INVALID = 'INVALID',
  SUCCESS = 'SUCCESS',
}
